var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRipleyBlanco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 344.21 490.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 7122"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 111"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 22",
    d: "M344.12 367c0-2.39-3.12-3.16-3.12-3.16-30.85-5.67-59.55-27.16-81.39-49.94a535.68 535.68 0 01-77.12-106.89c-3.48-8 1.47-8.82 1.47-8.82v-.12C244 175 254 115 254 98.51 254 22.41 181.91 0 117 0 92.46 0 84.31 2 58.71 2 29.09 2 11.26 0 6.63 0A6.9 6.9 0 000 7.16a3.4 3.4 0 000 .45c0 18.46 41.86-12.74 41.86 48.6v244.67C41.86 357.57 2 341.73 2 355.51c0 4.64 5.11 6.17 8.15 6.17 14.86 0 31.69-2 55.7-2 30.19 0 37.81 2 55.19 2 12.74 0 14.87-2.57 14.87-6.17 0-17.35-53.69 9.28-53.69-64.32V33.13c0-15.29 11.24-15.29 27.6-15.29 58.74 0 105.31 32.75 106.26 94.53.62 41.9-30.67 81.77-82.78 81.77a85.58 85.58 0 01-18.5-1.17c-2.5 0-5.07 1.06-5.07 4.59 0 4.72 3.86 7.1 8.22 8.41a54.66 54.66 0 0132.58 25.6C185.49 288.63 224.65 374 314 374c33.49 0 30.15-3.93 30.15-7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 110"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.43 473.45a17 17 0 1117.06 16.87A17 17 0 01.43 473.45z",
    fill: "#fff",
    "data-name": "Trazado 23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.26 447.45a42.15 42.15 0 0141.42-42.87h1.78a41.71 41.71 0 0137 20.92l-23.07 13.37A16.31 16.31 0 1081.28 464a15.49 15.49 0 0014.11-8.09l23.09 13.29a41.56 41.56 0 01-37 21.11 42.15 42.15 0 01-43.19-41.08c-.04-.59-.04-1.23-.03-1.78z",
    fill: "#fff",
    "data-name": "Trazado 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53 447.45a43.37 43.37 0 1143.88 42.86h-.53a42.74 42.74 0 01-43.35-42.1zm59.73 0a16.31 16.31 0 10-16.37 16.89 16 16 0 0016.39-15.56 11.81 11.81 0 00-.02-1.33z",
    fill: "#fff",
    "data-name": "Trazado 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.75 438.37v49.68h-27.09v-46.64c0-7-3.23-11.36-10.06-11.36-7.65 0-11.22 5.52-11.22 13.64v44.36h-27v-46.64c0-7-3.39-11.36-10.18-11.36-7.45 0-11.18 5.52-11.18 13.64v44.36h-27v-81.22h27v7.7a25.82 25.82 0 0121.91-10A23.12 23.12 0 01289.69 415a28.65 28.65 0 0123.63-10.4c18.62-.02 30.43 12.66 30.43 33.77z",
    fill: "#fff",
    "data-name": "Trazado 26"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRipleyBlanco);
export default __webpack_public_path__ + "static/media/logo-ripley-blanco.e35aaa88.svg";
export { ForwardRef as ReactComponent };